// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import Html from 'Component/Html';
import { AgreementType } from 'Type/Account.type';
import { MixType, RefType } from 'Type/Common.type';
import { EventsType, FieldAttrType } from 'Type/Field.type';

import './FormAgreement.style';

/** @namespace PeggysagePwa/Component/FormAgreement/Component */
export class FormAgreementComponent extends PureComponent {
    static propTypes = {
        agreement: AgreementType.isRequired,
        attr: FieldAttrType.isRequired,
        events: EventsType.isRequired,
        mix: MixType.isRequired,
        labelRef: RefType.isRequired
    };

    renderCheckbox() {
        const {
            agreement: { checkbox_text }, attr, events, mix, labelRef
        } = this.props;

        return (
            <Field
              type={ FIELD_TYPE.checkbox }
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
              label={ <span ref={ labelRef }><Html content={ checkbox_text } /></span> }
              attr={ attr }
              events={ events }
              validateOn={ ['onChange'] }
              validationRule={ {
                  isRequired: true
              } }
              mix={ mix }
              addRequiredTag
            />
        );
    }

    render() {
        return (
            <div block="FormAgreement">
                { this.renderCheckbox() }
            </div>
        );
    }
}

export default FormAgreementComponent;
